export function setCursorPosition(el, position) {
  const range = document.createRange();
  const sel = window.getSelection();
  const text = el.innerText;
  range.setStart(el.childNodes[0] || el, Math.min(position, text.length));
  range.collapse(true);
  sel.removeAllRanges();
  sel.addRange(range);
}

export function hashString(str) {
  let hash = 0;
  if (str.length === 0) return hash;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }
  return hash;
}

export function getSpeakerColor(name, alpha = 1) {
  const index = hashString(name) % 360;
  const hue = index * 137.508; // use golden angle approximation
  return `hsla(${hue},50%,50%,${alpha})`;
}
